import React from "react";
import { Bell, Search } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function Topbar({ title, breadcrumb }) {
  const { user } = useAuth();
  return (
    <div className="bg-white border-b border-slate-200 px-8 py-4 flex items-center justify-between sticky top-0 z-10">
      <div className="min-w-0">
        {breadcrumb && (
          <div data-testid="topbar-breadcrumb" className="uppercase-track flex items-center gap-2 mb-1">
            {breadcrumb.map((b, idx) => (
              <React.Fragment key={`${b}-${idx}`}>
                <span className={idx === breadcrumb.length - 1 ? "text-orange-600" : "text-slate-400"}>
                  {b}
                </span>
                {idx < breadcrumb.length - 1 && <span className="text-slate-300">›</span>}
              </React.Fragment>
            ))}
          </div>
        )}
        <h1 data-testid="topbar-title" className="text-xl font-semibold text-slate-900 tracking-tight">
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-3">
        <div className="hidden md:flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-full px-3 py-1.5 w-72">
          <Search size={14} className="text-slate-400" />
          <input
            data-testid="topbar-search"
            placeholder="Search anything…"
            className="bg-transparent text-sm outline-none flex-1 placeholder:text-slate-400"
          />
        </div>
        <button
          data-testid="topbar-bell"
          className="w-9 h-9 grid place-items-center rounded-full bg-slate-50 hover:bg-slate-100 text-slate-600 border border-slate-200"
        >
          <Bell size={16} />
        </button>
        <div className="hidden md:flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-full bg-orange-500 text-white grid place-items-center text-sm font-semibold">
            {(user?.name || "U").slice(0, 1).toUpperCase()}
          </div>
        </div>
      </div>
    </div>
  );
}
